import { Component, Input, OnInit } from "@angular/core";
import { DataTableDirective, SortEvent } from "./data-table.directive";

@Component({
	selector: "app-default-sorter",
	templateUrl: "default-sorter.component.html",
	standalone: false
})
export class DefaultSorterComponent implements OnInit {
	@Input() by: string;
	@Input() market: string;
	@Input() groupCode: string;

	isSortedByMeDesc = false;
	isSortedByMeAsc = false;

	constructor(private mfTable: DataTableDirective) { }

	ngOnInit(): void {
		this.mfTable.onSortChange.subscribe((event: SortEvent) => {
			this.isSortedByMeAsc =
				event.sortBy === this.by && event.sortOrder === "asc";
			this.isSortedByMeDesc =
				event.sortBy === this.by && event.sortOrder === "desc";
		});
	}

	sort() {
		this.mfTable.setSort(
			this.by,
			this.isSortedByMeAsc ? "desc" : "asc",
			this.market,
			this.groupCode
		);
	}
}
